export default {
  title: 'Payments log',

  labels: {
    type: 'Type',
    id: 'Id'
  },

  tabs: {
    request: 'Request',
    response: 'Response'
  },

  directions: {
    incoming: 'Incoming',
    outgoing: 'Outgoing'
  },

  hints: {
    notFound: 'No records found'
  }
}
